import { NetworkService } from '../../services';
import { BuildingConstants } from './types';
import { config } from '../../config';
import {
  HELP_SUBCATEGORY,
  HELP_CATEGORY,
  ACCOUNT_CATEGORY,
  SETTINGS_CATEGORY,
} from '../../components/NavBar/navConstants';

// API endpoints

const { BASE_URL, BUILDING_URL } = config;

export class BuildingActions {
  static getBuildingList() {
    // call api and get list of buildings for user
    return async (dispatch) => {
      const requestOptions = NetworkService.getRequestOptions('GET');

      const response = await fetch(`${BASE_URL}${BUILDING_URL}?partial=1`, requestOptions);
      if (!response || !response.ok || response === 'error') {
        return dispatch(BuildingActions.setSelectedBuildingError());
      }

      const data = await response.json();
      await dispatch({ type: BuildingConstants.SetBuildingsList, payload: data });
      return dispatch(BuildingActions.setInitialConditions(data));
    };
  }

  static getBuildingStatusList() {
    // call api and get list of building statuses
    return async (dispatch) => {
      const requestOptions = NetworkService.getRequestOptions('GET');

      const response = await fetch(`${BASE_URL}${BUILDING_URL}status/`, requestOptions);
      if (!response || !response.ok || response === 'error') {
        return dispatch(BuildingActions.setSelectedBuildingError());
      }

      const data = await response.json();
      return dispatch({ type: BuildingConstants.SetBuildingStatusList, payload: data });
    };
  }

  static setInitialConditions() {
    return async (dispatch, getState) => {
      const buildingList = getState().buildingReducer.buildingsList;
      const foundBuilding =
        buildingList.find((building) => window.location.pathname.includes(building.identifier)) || buildingList[0];

      await dispatch(BuildingActions.setSelectedBuilding(foundBuilding.identifier));

      if (window.location.pathname === '/help') {
        return dispatch(BuildingActions.setNavigationParams(HELP_CATEGORY, HELP_SUBCATEGORY));
      }

      if (window.location.pathname.startsWith('/account')) {
        const foundCategory = ACCOUNT_CATEGORY;
        const foundSubCategory = foundCategory
          ? foundCategory.sub_categories.find((subCategory) => window.location.pathname.includes(subCategory.id))
          : foundCategory.sub_categories[0];
        return dispatch(BuildingActions.setNavigationParams(ACCOUNT_CATEGORY, foundSubCategory));
      }

      if (window.location.pathname.startsWith('/settings')) {
        const foundCategory = SETTINGS_CATEGORY;
        const foundSubCategory = foundCategory
          ? foundCategory.sub_categories.find((subCategory) => window.location.pathname.includes(subCategory.id))
          : foundCategory.sub_categories[0];
        return dispatch(BuildingActions.setNavigationParams(SETTINGS_CATEGORY, foundSubCategory));
      }

      const building = getState().buildingReducer.selectedBuilding;
      const foundCategory = building.navigation.find((category) => window.location.pathname.includes(category.id));
      const foundSubCategory = foundCategory
        ? foundCategory.sub_categories.find((subCategory) => window.location.pathname.includes(subCategory.id))
        : building.navigation[0].sub_categories[0];
      await dispatch(BuildingActions.setNavigationParams(foundCategory || building.navigation[0], foundSubCategory));
    };
  }

  static changeBuilding(identifier) {
    return async (dispatch, getState) => {
      await dispatch(BuildingActions.setSelectedBuilding(identifier));

      const building = getState().buildingReducer.selectedBuilding;

      await dispatch(
        BuildingActions.setNavigationParams(building.navigation[0], building.navigation[0].sub_categories[0]),
      );
    };
  }

  static setSelectedBuilding(identifier) {
    // call api and store selected building in redux
    return async (dispatch) => {
      const requestOptions = NetworkService.getRequestOptions('GET');

      const response = await fetch(`${BASE_URL}${BUILDING_URL}${identifier}/?partial=1`, requestOptions);

      if (!response | !response.ok | (response === 'error')) {
        return dispatch(BuildingActions.setSelectedBuildingError());
      }

      const data = await response.json();
      return dispatch({ type: BuildingConstants.SetSelectedBuilding, payload: data });
    };
  }

  static setNavigationParams(category, subcategory) {
    const navigationParams = {
      selectedCategory: category,
      selectedSubCategory: subcategory,
    };

    return { type: BuildingConstants.SetNavigationParams, payload: navigationParams };
  }

  static setSelectedBuildingError() {
    return { type: BuildingConstants.SetSelectedBuildingError };
  }

  static clearSelectedBuildingError() {
    return { type: BuildingConstants.ClearSelectedBuildingError };
  }
}
